import ShoppingCartIcon from '@heroicons/react/24/solid/ShoppingCartIcon';
import React from 'react';

interface EmptyCartModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const EmptyCartModal: React.FC<EmptyCartModalProps> = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
    <div className="bg-white p-8 rounded-lg shadow-lg text-center">
      {/* Cart Icon */}
      <ShoppingCartIcon className="mx-auto h-16 w-16 text-blue-500 mb-4" />
      
      {/* Empty Cart Title */}
      <h2 className="text-2xl font-bold mb-2 text-slate-800">Your Cart is Empty</h2>
      
      {/* Description */}
      <p className="text-gray-500 mb-6">Add something to make me happy :)</p>
      
      {/* Continue Shopping Button */}
      <button  onClick={onClose} className="bg-blue-500 hover:bg-blue-600 text-white font-medium px-6 py-2 rounded-full">
      Close
      </button>
    </div>
  </div>
  );
};

export default EmptyCartModal;
